import { FC, useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Invoice } from "./Invoice";
import { SteppedInvoice } from "./SteppedInvoice";
import { ROUTES } from "../../routes";
import { setVideoAskUrl } from "../../store/reducers/ui";
import { useGetInvoiceQuery } from "../../store/services/invoices";
import { useGetWalletsQuery } from "../../store/services/wallets";
import { InvoiceStatus } from "../../types/InvoiceTypes";
import { isMobileMedia } from "../../utils/media";

export const InvoicePage: FC = () => {
  const { id = "" } = useParams();
  const { data: invoice } = useGetInvoiceQuery({ id });
  useGetWalletsQuery();
  const dispatch = useDispatch();

  // Video guide
  useEffect(() => {
    if (
      invoice?.status &&
      [InvoiceStatus.PENDING, InvoiceStatus.PENDING_REVIEW].includes(
        invoice.status
      )
    ) {
      dispatch(setVideoAskUrl("https://www.videoask.com/fyy3utq3h"));
    }

    return () => {
      dispatch(setVideoAskUrl(null));
    };
  }, [dispatch, invoice?.status]);

  if (!id) {
    return (
      <Navigate to={invoice?.user_is_payer ? ROUTES.PAY : ROUTES.RECEIVE} />
    );
  }

  if (id !== invoice?.id) {
    return <></>;
  }

  const InvoicePage = isMobileMedia() ? <SteppedInvoice /> : <Invoice />;

  return <>{InvoicePage}</>;
};
